import React from "react";

import styles from "./Spinner.module.css";

type SpinnerProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
};

export const Spinner: React.FC<SpinnerProps> = ({ size = "md", className }) => {
  const classes = [styles.spinner, styles[`size-${size}`], className]
    .filter(Boolean)
    .join(" ");

  return <div className={classes} aria-label="Loading" role="status" />;
};
